var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ImageItemValueWrapperViewModel } from "survey-creator-core";
import * as React from "react";
import { LoadingIndicatorComponent, ReactElementFactory, SvgIcon } from "survey-react-ui";
import { attachKey2click, } from "survey-react-ui";
import { CreatorModelElement } from "./ModelElement";
var ImageItemValueAdornerComponent = /** @class */ (function (_super) {
    __extends(ImageItemValueAdornerComponent, _super);
    function ImageItemValueAdornerComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.preventDragHandler = function (e) {
            e.preventDefault();
        };
        _this.rootRef = React.createRef();
        return _this;
    }
    ImageItemValueAdornerComponent.prototype.createModel = function (props) {
        this.model = new ImageItemValueWrapperViewModel(props.componentData.creator, props.question, props.item, null, null);
    };
    ImageItemValueAdornerComponent.prototype.getUpdatedModelProps = function () {
        return ["question", "item"];
    };
    ImageItemValueAdornerComponent.prototype.getStateElement = function () {
        return this.model;
    };
    Object.defineProperty(ImageItemValueAdornerComponent.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    ImageItemValueAdornerComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.model.itemsRoot = this.rootRef.current;
    };
    ImageItemValueAdornerComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.model.itemsRoot = this.rootRef.current;
    };
    ImageItemValueAdornerComponent.prototype.renderLoadingIndicator = function () {
        return React.createElement("div", { className: "svc-image-item-value__loading" },
            React.createElement(LoadingIndicatorComponent, null));
    };
    ImageItemValueAdornerComponent.prototype.renderNewItemControls = function () {
        var _this = this;
        var addButton = attachKey2click(React.createElement("span", { className: this.model.addButtonCss, onClick: function () { return _this.model.chooseNewFile(_this.model); } }, this.model.showChooseButtonAsIcon ?
            React.createElement(SvgIcon, { size: "auto", iconName: "icon-add-lg", title: this.model.addFileTitle }) :
            React.createElement("span", null, this.model.chooseImageText)));
        var placeholder = this.model.showPlaceholder ? React.createElement("span", { className: "svc-image-item-value__placeholder" }, this.model.placeholderText) : null;
        return React.createElement(React.Fragment, null,
            placeholder,
            addButton);
    };
    ImageItemValueAdornerComponent.prototype.render = function () {
        var _this = this;
        this.model.item = this.props.item;
        var isNew = !this.props.question.isItemInList(this.props.item);
        this.model.isNew = isNew;
        var imageStyle = !this.model.getIsNewItemSingle() ? { width: this.question.renderedImageWidth, height: this.question.renderedImageHeight } : null;
        var content = null;
        if (isNew || this.model.isUploading) {
            content = (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "svc-image-item-value__item" },
                    React.createElement("div", { className: "sd-imagepicker__item sd-imagepicker__item--inline" },
                        React.createElement("label", { className: "sd-imagepicker__label" },
                            React.createElement("div", { style: imageStyle, className: "sd-imagepicker__image" }, this.model.isUploading ? this.renderLoadingIndicator() : null)))),
                this.model.allowAdd && !this.model.isUploading ?
                    React.createElement("div", { className: "svc-image-item-value-controls" }, this.renderNewItemControls())
                    : null));
        }
        else {
            content = (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "svc-image-item-value__item" }, this.props.element),
                this.model.isDraggable && this.model.canRenderControls ?
                    React.createElement("span", { className: "svc-context-button svc-image-item-value-controls__drag-area-indicator", onPointerDown: function (event) { return _this.model.onPointerDown(event); } },
                        React.createElement(SvgIcon, { size: "auto", iconName: "icon-drag-24x24" }))
                    : null,
                this.model.canRenderControls ?
                    React.createElement("div", { className: "svc-context-container svc-image-item-value-controls" },
                        this.model.allowRemove && !this.model.isUploading ? attachKey2click(React.createElement("span", { className: "svc-context-button", onClick: function () { return _this.model.chooseFile(_this.model); } },
                            React.createElement(SvgIcon, { role: "button", size: "auto", iconName: "icon-choosefile", title: this.model.selectFileTitle }))) : null,
                        this.model.allowRemove && !this.model.isUploading ? attachKey2click(React.createElement("span", { className: "svc-context-button svc-context-button--danger", onClick: function () { return _this.model.remove(_this.model); } },
                            React.createElement(SvgIcon, { role: "button", size: "auto", iconName: "icon-delete", title: this.model.removeFileTitle }))) : null)
                    : null));
        }
        return (React.createElement("div", { ref: this.rootRef, className: this.model.getRootCss(), key: this.props.element.key, "data-sv-drop-target-item-value": this.model.isDraggable ? this.model.item.value : undefined, onPointerDown: function (event) { return _this.model.onPointerDown(event); }, onDragStart: this.preventDragHandler, onDrop: this.model.onDrop, onDragEnter: this.model.onDragEnter, onDragOver: this.model.onDragOver, onDragLeave: this.model.onDragLeave },
            React.createElement("div", { className: "svc-image-item-value-wrapper__ghost", style: imageStyle }),
            React.createElement("div", { className: "svc-image-item-value-wrapper__content" },
                React.createElement("input", { type: "file", "aria-hidden": "true", tabIndex: -1, accept: this.model.acceptedTypes, className: "svc-choose-file-input", style: {
                        position: "absolute",
                        opacity: 0,
                        width: "1px",
                        height: "1px",
                        overflow: "hidden"
                    } }),
                content)));
    };
    return ImageItemValueAdornerComponent;
}(CreatorModelElement));
export { ImageItemValueAdornerComponent };
ReactElementFactory.Instance.registerElement("svc-image-item-value", function (props) {
    return React.createElement(ImageItemValueAdornerComponent, props);
});
